module.exports = __webpack_public_path__ + "img/05.b6a0c60a.jpg";